import { createFileRoute, notFound } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { saMenuItems } from "@/lib/sa-menu";
import { SaPlansPanel } from "@/components/sa/SaPlansPanel";
import { SaCentersPanel } from "@/components/sa/SaCentersPanel";
import { SaAccountsPanel } from "@/components/sa/SaAccountsPanel";
import { SaSubscriptionsPanel } from "@/components/sa/SaSubscriptionsPanel";

export const Route = createFileRoute("/_authenticated/sa/$slug")({
  beforeLoad: ({ params }) => {
    if (!saMenuItems.some((i) => i.slug === params.slug)) throw notFound();
  },
  component: SaSlugPage,
  notFoundComponent: () => <p className="text-muted-foreground">Página não encontrada.</p>,
});

function SaSlugPage() {
  const { slug } = Route.useParams();
  const item = saMenuItems.find((i) => i.slug === slug)!;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{item.title}</h1>
      </div>
      {renderPanel(slug)}
    </div>
  );
}

function renderPanel(slug: string) {
  switch (slug) {
    case "assinaturas":
      return (
        <div className="space-y-8">
          <SaSubscriptionsPanel />
          <div>
            <h2 className="mb-3 text-lg font-semibold">Planos de assinatura</h2>
            <SaPlansPanel />
          </div>
        </div>
      );
    case "centros":
      return <SaCentersPanel />;
    case "contas":
      return <SaAccountsPanel />;
    default:
      return (
        <Card className="p-6">
          <p className="text-sm text-muted-foreground">
            Módulo em construção. Ele será liberado na próxima etapa da administração do sistema.
          </p>
        </Card>
      );
  }
}
